import React, { createContext, useContext, useEffect, useRef, useState } from "react";

// Context creation
const GroupTaskWebSocketContext = createContext();

export const GroupTaskWebSocketProvider = ({ children }) => {
  const [taskUrlsMap, setTaskUrlsMap] = useState({});     // key => [urls]
  const [taskDataMap, setTaskDataMap] = useState({});     // key => [data]
  const socketRefs = useRef({});                          // key => [WebSocket refs]

  const registerTask = (key, url) => {
    if (!key || !url) return;

    setTaskUrlsMap(prev => {
      const updatedUrls = Array.from(new Set([...(prev[key] || []), url]));
      return { ...prev, [key]: updatedUrls };
    });

    const ws = new WebSocket(url);

    ws.onopen = () => console.log(`WebSocket connected: [${key}] -> ${url}`);

    ws.onmessage = (event) => {
      try {
        const data = JSON.parse(event.data);

        setTaskDataMap(prev => ({
          ...prev,
          [key]: [...(prev[key] || []), data]
        }));
      } catch (e) {
        console.warn("Invalid JSON message", e);
      }
    };

    ws.onerror = (e) => console.error(`WebSocket error: [${key}] -> ${url}`, e);

    socketRefs.current[key] = [...(socketRefs.current[key] || []), ws];
  };

  const getAllData = () => {
    return Object.values(taskDataMap).flat();
  };
  const getDataById = (key) => {
    return taskDataMap[key] || [];
    };
  useEffect(() => {
    return () => {
      Object.values(socketRefs.current).flat().forEach(ws => {
        if (ws.readyState === WebSocket.OPEN) ws.close();
      });
    };
  }, []);

  return (
    <GroupTaskWebSocketContext.Provider value={{ registerTask, taskUrlsMap, taskDataMap, getAllData ,getDataById}}>
      {children}
    </GroupTaskWebSocketContext.Provider>
  );
};

// Custom hook
export const useGroupTaskWebSocket = () => useContext(GroupTaskWebSocketContext);
